export default {
  title: "Восстановление пароля",
  back: "Вернуться назад",
  submit: "Отправить",
  successMessage:
    "На указанную почту выслана ссылка <br /> для восстановления пароля"
};
